import { useForm as useFormHook } from "hooks";
import type { PaymentMethodLimits, PaymentMethodLimitsForm } from "./types";

const numericFields: Array<keyof PaymentMethodLimits> = [
    'minTicketSize',
    'maxTicketSize',
    'maxNumberOfTransaction24',
    'maxNumberOfTransactionWeek',
    'maxNumberOfTransactionMonth',
    'maxTotalAmountWeek',
    'maxNumberOfTransactionProfile24',
    'maxTotalAmountProfile24',
    'maxTotalAmountMonth',
    'velocity',
    'maxRiskLevel'
];

export const getInitialValues = (initialValues?: Partial<PaymentMethodLimits>) => {
    const values = { ...initialValues };

    numericFields.forEach(field => {
        const value = (values as Record<string, unknown>)[field];

        if (typeof value === 'string' && value.trim() !== '' && Number.isFinite(Number(value))) {
            (values as Record<string, unknown>)[field] = Number(value);
        }
    });

    return values;
};

export const useForm = (paymentMethodLimitsProps: PaymentMethodLimitsForm) =>
    useFormHook<PaymentMethodLimits>({
        enableReinitialize: true,
        ...paymentMethodLimitsProps,
        initialValues: getInitialValues(paymentMethodLimitsProps.initialValues)
    });
